module.exports = __webpack_public_path__ + "static/yikai-5eca2e204aa4b57048fa0854b8aad557.jpg";